import { useState } from "react";
import { useTranslation } from "react-i18next";
import InvoiceArchiveTable from "@/components/organisms/InvoiceArchiveTable";
import styles from "./styles.module.css";
import { SubHeader } from "@/components/molecules/SubHeader";

export default function InvoiceArchive() {
  const { t } = useTranslation();
  const [totalItems, setTotalItems] = useState(0);

  return (
    <>
      <title>{`Reviver - ${t("common:archivedDocuments")}`}</title>
      <meta name="description" content={t("common:archivedDocuments")} />
      <SubHeader title={t("navigation:archive")} count={totalItems} countLabel={t("common:archivedDocuments")} />
      <div className={styles.archiveRoot}>
        <div className={styles.contentRoot}>
          <InvoiceArchiveTable initialRowsPerPage={15} onTotalItemsChange={setTotalItems} />
        </div>
      </div>
    </>
  );
}
